export default __webpack_public_path__ + "static/media/btn-zeroback-start-es_es@3x.49672487.png";